// checklistItemUtils.js

import { generateKey } from 'utilities/Keys';

export const createEmptyChecklistItem = (position = 0) => ({
    key: generateKey(),
    text: '',
    position,
    status: 'todo',
    completedAt: null,
    assignees: [],
    source: 'custom',
});

export const cloneChecklistItems = (items) => {
    const list = Array.isArray(items) ? items : [];

    return list.map((item, itemIndex) => {
        const sourceRaw = String(item?.source || '').trim().toLowerCase();
        const source = sourceRaw === 'template' || sourceRaw === 'custom'
            ? sourceRaw
            : undefined;
        const templateKey = String(item?.templateKey || '').trim()
            || (source === 'template' ? String(item?.key || '').trim() : '');

        return {
            key: String(item?.key || `item_${itemIndex}`).trim(),
            text: String(item?.text || '').trim(),
            position: Number.isFinite(Number(item?.position)) ? Number(item.position) : itemIndex,
            status: String(item?.status || '').trim().toLowerCase() === 'done' ? 'done' : 'todo',
            completedAt: item?.completedAt || null,
            assignees: Array.isArray(item?.assignees) ? item.assignees : [],
            ...(source ? { source } : {}),
            ...(templateKey ? { templateKey } : {}),
        };
    });
};

export const toggleChecklistItemStatus = (items, itemKey) => (
    cloneChecklistItems(items).map((item) => {
        if (item.key !== itemKey) return item;

        return {
            ...item,
            status: item.status === 'done' ? 'todo' : 'done',
            completedAt: item.status === 'done' ? null : item.completedAt,
        };
    })
);

export const updateChecklistItemText = (items, itemKey, text) => (
    items.map((item) => {
        if (item.key !== itemKey) return item;

        return {
            ...item,
            text: String(text || ''),
        };
    })
);

export const addChecklistItem = (items) => {
    const nextItems = cloneChecklistItems(items);

    return [
        ...nextItems,
        createEmptyChecklistItem(nextItems.length),
    ];
};

export const moveChecklistItem = (items, sourceItemKey, targetItemKey) => {
    const nextItems = cloneChecklistItems(items);
    const sourceIndex = nextItems.findIndex((item) => item.key === sourceItemKey);
    const targetIndex = nextItems.findIndex((item) => item.key === targetItemKey);

    if (sourceIndex === -1 || targetIndex === -1 || sourceIndex === targetIndex) {
        return nextItems;
    }

    const [movedItem] = nextItems.splice(sourceIndex, 1);
    nextItems.splice(targetIndex, 0, movedItem);

    return nextItems.map((item, itemIndex) => ({
        ...item,
        position: itemIndex,
    }));
};

export const removeChecklistItem = (items, itemKey) => (
    cloneChecklistItems(items)
        .filter((item) => item.key !== itemKey)
        .map((item, itemIndex) => ({
            ...item,
            position: itemIndex,
        }))
);
